import { SolutionLayout } from "@/components/shikra/SolutionLayout";

const CAPABILITIES = [
  {
    title: "Feeder-level hosting capacity",
    description:
      "Physics-based twins compute the true renewable headroom of every feeder and transformer, so that new connections are backed by evidence, and not just heuristic rules of thumb.",
  },
  {
    title: "Automated curtailment minimisation",
    description:
      "Dispatch setpoints are recomputed continuously to absorb the maximum renewable output the network can physically carry, cutting curtailment without violating operating limits, and maximising the value of the existing transmission network.",
  },
  {
    title: "Sub-second frequency response",
    description:
      "Battery and inverter response executes at every substation edge, holding frequency and voltage within grid code through ramps, cloud events and faults.",
  },
  {
    title: "Duck-curve mitigation & peak shaving",
    description:
      "Our load forecast models estimate the evening ramp and midday trough, and help plan for day-ahead markets, with storage and flexible load scheduled to flatten the net-load curve before it stresses the network.",
  },
  {
    title: "Asset-health-aware operation",
    description:
      "Every control action we make is carefully weighed against transformer and battery wear, so compliance and renewable absorption don't quietly shorten asset life. Our digital twins also estimate the Remaining Useful Life of network assets, ensuring that the grid is never caught off-guard by sudden failures.",
  },
  {
    title: "SCADA / ADMS integration",
    description:
      "Shikra deploys alongside and on top of existing utility systems. Data from our real-time controllers at every substation ensure data is always flowing into your control room. Nothing you run today gets replaced; only enhanced.",
  },
];

const STEPS = [
  {
    label: "Model",
    title: "We twin your network",
    description:
      "A physics-based digital twin is built from your feeder data, asset registers and historical load, all the way down to individual transformers.",
  },
  {
    label: "Shadow",
    title: "We prove it in shadow mode",
    description:
      "The system runs alongside live operations, and its recommendations are scored against reality, so that you can evaluate our performance even before anything is implemented.",
  },
  {
    label: "Control",
    title: "We close the loop",
    description:
      "Our software helps your operators make informed decisions, faster and more effectively. Custom metrics, diagnostics, and control strategies ensure that your operators are always equipped with the information they need.",
  },
];

export default function ForUtilities() {
  return (
    <SolutionLayout
      testid="solution-page-utilities"
      eyebrow="Solutions / For Utilities - DISCOMs"
      title="Grid-side control for renewable-heavy distribution networks."
      lead="Rooftop solar, utility-scale parks and open-access wind are landing on distribution networks faster than the networks were designed for. Shikra Energy gives your control room the visibility, forecasts and real-time control needed to absorb that growth without compromising reliability."
      capabilities={CAPABILITIES}
      steps={STEPS}
      ctaText="Tell us about your network."
    />
  );
}
